/// <amd-module name="Dashboards/WidgetContracts/Internal/WidgetCatalogEntry" />
import { WidgetGridSize } from "./DashboardWidgetProps";
import { WidgetContributionRenderingProps } from "./WidgetContributionTypes";

/**
 * Properties for Exposing information about Widgets from Catalog Experiences
 */
export interface WidgetContributionCatalogProperties {
    /**
     * Name of Widget for presentation in Widget Catalog.
     */
    name: string;

    /**
     * Url of Image for presentation in Widget Catalog.
     */
    catalogIconUrl: string;

    /**
     * Additional information link for the widget for use by the Catalog.
     */
    catalogInfoURI: string;

    /**
     * User facing description for widget Catalog.
     */
    description: string;

    /**
     * User facing name of publisher for widget catalog.
     */
    publisherName: string;

    /**
     * Covers Two Scenarios:
     * 1-Allows for legacy widgets to be suppressed to provide a graceful phase-out experience
     * 2-(STRONGLY NOT RECOMMENDED) For Widgets which are pinnable, and don't have a config experience. At this point, all stateful widgets should ship with config on day 1.
     */
    isVisibleFromCatalog: boolean;

    /**
     * Tags describing a Widget's features, displayed with each Widget Entry
     */
    tags: string[] | undefined;

    /**
     * Keywords associated with a Widget based on their tags
     */
    keywords: string[] | undefined;
}

/***
 * Properties for facilitating Widget Configuration Experiences.
 */
export interface WidgetContributionConfigProps {
    configContributionId: string;

    /**
     * Indicates if platform should provide a configuration affordance for name property.
     */
    isNameConfigurable: boolean;

    /** Sizes supported by the widget.
     * The first is used as a default in Configuration Experiences.
     */
    supportedSizes: WidgetGridSize[];
}

/**
 * Aspects of Widget Contribution property object with significance to WidgetHost.
 *
 * Subdivided in terms of Widget
 *
 */
export interface WidgetContributionDetails
    extends WidgetContributionRenderingProps,
        WidgetContributionCatalogProperties,
        WidgetContributionConfigProps {}

/**
 * Supplemental information about a widget, which is not actually sourced from the Widget contribution properties object.
 */
export interface ComputedWidgetProps {
    /**
     * Identifier of this contribution.
     */
    contributionId: string;

    /**
     * Default size of a new Widget
     */
    defaultSize: WidgetGridSize;
}

/** Provides discoverability information about a widget for creational scenarios. */
export interface WidgetCatalogEntry extends WidgetContributionDetails, ComputedWidgetProps {}
